import mobileDetection from '@/mixins/mobile-detection';

const supportedTags = ['input', 'textarea'];

function focusElement(el, binding) {
  if (mobileDetection.methods.detectMobile()) {
    return;
  }

  // Allows use with custom components.
  if (!supportedTags.includes(el.tagName.toLowerCase())) {
    el = el.querySelector(supportedTags.join(', '));
  }

  // During transitions, this can be null.
  if (!el) {
    return;
  }

  // NOTE: null, undefined and truthy should cause focus.
  if (binding.value == null || binding.value) {
    el.focus();
  }
}

export default function (Vue) {
  Vue.directive('focus', {
    inserted: function (el, binding) {
      focusElement(el, binding);
    },

    activated: function (el, binding) {
      focusElement(el, binding);
    },
  });

  Vue.directive('visible', (el, binding) => {
    el.style.visibility = binding.value ? 'visible' : 'hidden';
  });
}
